import axios from 'axios';
import { stringify, parse } from 'qs';

import config from '@/config';

export const axiosConfig = {
    baseURL: config.API_BASE_URL,
    timeout: config.API_TIMEOUT,
    withCredentials: true,
    maxRedirects: 0,
    paramsSerializer: {
        encode: parse,
        serialize: params => stringify(params, { arrayFormat: 'repeat' })
    }
};

const http = axios.create(axiosConfig);

export const baseURL = http.defaults.baseURL;

export default http;
